import React from 'react'

import { Field } from 'formik'

import { Form, Col } from '_zari/core'

const SerieDocumentoFormGroup = ({ iError, iTouched, fIsSubmitting }) => {
  return (
    <Form.Group>
      <Form.Label text='SERIE DOCUMENTO' htmlFor='input-serieDocumento' md={4} alignRightAt='md' />
      <Col md={8}>
        <Field name='serieDocumento'>
          {({ field }) => (
            <Form.InputText
              {...field}
              id='input-serieDocumento'
              isInvalid={iTouched && iError}
              disabled={fIsSubmitting}
            />
          )}
        </Field>
        {iTouched && iError ? <Form.Feedback type='invalid'>{iError}</Form.Feedback> : null}
      </Col>
    </Form.Group>
  )
}

export default React.memo(SerieDocumentoFormGroup)
